<template>
  <div class="container">
    <div class="heum-report-hero">
      <div class="heum-report-hero__container">
        <div class="heum-report-hero__contents">
          <div class="heum-report-hero__subtitle">
            HeumReport
          </div>
          <div class="heum-report-hero__title">
            가장 편리한 세무시스템을<br />
            경험해보세요.
          </div>
          <div class="heum-report-hero__btns">
            <a href="/consulting" class="btn btn--primary btn--large">
              {{
                displayPartnerContent('상담 신청하기', 'consultingButtonText')
              }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <content-section>
      <service-detail
        :service-data="SERVICE_DETAIL_LIST['알람시스템']"
        :service-type="'알람시스템'"
      />
    </content-section>
    <content-section bg-color="#fafafa">
      <service-detail
        :horizontal="true"
        :service-data="SERVICE_DETAIL_LIST['세무시스템']"
        :service-type="'세무시스템'"
      />
    </content-section>
    <content-section>
      <service-detail
        :service-data="SERVICE_DETAIL_LIST['급여시스템']"
        :service-type="'급여시스템'"
      />
    </content-section>
    <content-section bg-color="#fafafa">
      <service-detail
        :horizontal="true"
        :service-data="SERVICE_DETAIL_LIST['보고시스템']"
        :service-type="'보고시스템'"
      />
    </content-section>
    <content-section>
      <main-partner />
    </content-section>
    <heum-join title="기술이 다른 혜움, 지금 바로 만나보세요." />
  </div>
</template>

<script>
import ContentSection from '~/components/common/content-section'
import ServiceDetail from '~/components/heum-service/service-detail'
import MainPartner from '~/components/main/main-partner'
import HeumJoin from '~/components/heum-join'

export default {
  layout: 'invert-font-header',
  head: {
    title: '혜움 시스템 - 세무법인혜움'
  },
  components: {
    ContentSection,
    ServiceDetail,
    MainPartner,
    HeumJoin
  },
  data: () => ({
    SERVICE_DETAIL_LIST: {
      알람시스템: {
        title: '친구처럼 챙겨주는 카톡 응대/알림 시스템',
        list: [
          {
            title: '맞춤 지원금 안내',
            description: '꼭 맞는 공제, 지원금까지 추천해드립니다.'
          },
          {
            title: '전담 채팅방',
            description:
              '전담 채팅방에서 기장직원,<br> 세무사가 같이 상담해 드립니다.'
          },
          {
            title: '주요 고지 알림',
            description:
              '꼭 챙겨야 할 지원금,<br> 납부 일정을 알아서 챙겨드립니다.'
          }
        ]
      },
      세무시스템: {
        title: '돈까지 절약해주는 세무 시스템',
        list: [
          {
            title: '자동 증빙 취합',
            description:
              '귀찮은 카드내역부터,<br> PG/온라인 매출까지 자동으로 취합합니다.'
          },
          {
            title: '절세 검토',
            description: '신고전 사전에 절세방안을 검토해드립니다.'
          },
          {
            title: '간편 고지 및 납부',
            description:
              '고지서를 카톡으로 보고,<br> 버튼한번으로 납부까지 하세요.'
          }
        ]
      },
      급여시스템: {
        title: '시간을 절약해주는 간편한 급여 시스템',
        list: [
          {
            title: '급여 명세서 간편 발송',
            description:
              '귀찮은 급여처리 버튼 한번으로 직원 급여명세서를 발송하세요.'
          },
          {
            title: '간편한 급여 입력',
            description:
              'Excel을 올리거나 수정하여<br> 간편하게  급여를 입력하세요.'
          },
          {
            title: '급여 이력 관리',
            description: '매달 4대 보험과 <br>급여이력을 확인하고 관리하세요.'
          }
        ]
      },
      보고시스템: {
        title: '비서처럼 도와주는 보고 시스템',
        list: [
          {
            title: '일간 자금 보고',
            description:
              '매일 발생하는<br> 매출, 매입, 은행계좌현황을 요약해드립니다.'
          },
          {
            title: '월간 손익 보고',
            description: '매달 매출, 손익, 비용 추이등을 보고해드립니다.'
          },
          {
            title: '카드 매출 관리',
            description: '카드사별<br> 승인, 입금, 취소 현황을 바로 확인하세요.'
          }
        ]
      }
    }
  })
}
</script>

<style lang="scss">
.heum-report-hero {
  position: relative;
  height: 460px;
  margin: 0 0 3.5rem 0;
  background: #000;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url('/images/heum-report/bg-heum-report-mobile.jpg');

  @include av-mq(lap-and-up) {
    height: 708px;
    margin: 0;
    background-image: url('/images/heum-report/bg-heum-report-desktop.jpg');
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0.4;
    mix-blend-mode: multiply;
    background-color: #000;
    z-index: 1;
  }

  &__container {
    position: relative;
    max-width: 1024px;
    height: 100%;
    margin: 0 auto;
    padding: 0 1rem;
  }

  &__contents {
    text-align: center;

    @include av-mq(lap-and-up) {
      position: absolute;
      top: 50%;
      left: 1rem;
      transform: translateY(-50%);
      z-index: 2;
      text-align: left;
    }
  }

  &__subtitle {
    position: absolute;
    bottom: 7.5rem;
    left: 0;
    width: 100%;
    font-size: 16px;
    color: #fff;
    z-index: 2;
    text-shadow: 0px 0px 20px #444;

    @include av-mq(lap-and-up) {
      position: static;
      font-size: 24px;
      margin-bottom: 1rem;
    }
  }

  &__title {
    position: absolute;
    bottom: 2rem;
    left: 0;
    width: 100%;
    font-size: 26px;
    line-height: 1.48;
    color: #fff;
    z-index: 2;
    text-shadow: 0px 0px 20px #444;

    @include av-mq(lap-and-up) {
      position: static;
      margin-bottom: 2rem;
      font-size: 48px;
    }
  }

  &__btns {
    .btn {
      transition: none;
      font-weight: bold;

      &.exp-button-color-1 {
        background: #ffdf00;
        border-color: #ffdf00;
        color: #1b1b1b;
      }
    }

    @include av-mq(pocket) {
      position: absolute;
      bottom: -3.5rem;
      left: 0;
      right: 0;
      z-index: 2;

      .btn {
        float: left;
        width: 100%;
        border-radius: 0;
        border: 0;
        padding: 1rem 0;
        font-size: 16px;
      }

      .btn--white {
        background-color: #ecf2fe;
        color: #1f75e8;
      }
    }

    @include av-mq(lap-and-up) {
      .btn {
        margin-right: 0.75rem;
      }
    }
  }
}
</style>
